/**============================================================
*   [form] formInputWP
*   description : フォームの入力画面処理（WP用）
============================================================*/
document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementsByClassName('mw_wp_form');

  // 入力画面では戻るボタンは非表示
  if (form.length !== 0) {
    const returnButton = document.getElementById('return');

    if (form[0].classList.contains('mw_wp_form_input') && returnButton) {
      returnButton.parentNode.removeChild(returnButton);
    }
  }
});

